import { NAPlug } from '~/models/gateways/netatmo/NAPlug.model';

export class NAVaillant extends NAPlug {
    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
}
